/**
 * Helper para facilitar integração com PrintQueueContext
 * Usa um singleton simples para acesso global sem hooks
 */

let adicionarNaFilaGlobal: ((job: any) => void) | null = null;

export const setPrintQueueInstance = (adicionarFn: (job: any) => void) => {
    adicionarNaFilaGlobal = adicionarFn;
};

export const adicionarImpressaoNaFila = (job: any) => {
    if (adicionarNaFilaGlobal) {
        adicionarNaFilaGlobal(job);
        return true;
    } else {
        console.warn('⚠️ [FILA] Contexto não inicializado - impressão direta será usada');
        return false;
    }
};

/**
 * Helper para criar job de impressão a partir de dados comuns
 */
export const criarJobImpressao = (params: {
    comandosEscPos: Uint8Array;
    dados: any;
    impressoraConfig: {
        deviceId?: string;
        address?: string;
        ip?: string;
        porta?: number;
        printerName?: string;
    };
    tipo: 'ble' | 'spp' | 'rede' | 'local';
    quantidadeVias: number;
    origem: string;
}) => {
    return {
        tipo: params.tipo,
        dados: params.dados,
        comandosEscPos: params.comandosEscPos,
        impressoraConfig: params.impressoraConfig,
        quantidadeVias: params.quantidadeVias,
        origem: params.origem
    };
};
